import styled from 'styled-components';
export const StyledBankChargeForm = styled.div`
  .form-group {
    padding: 0;
  }

  .DayPickerInput {
    width: 100%;
  }

  .details {
    padding-bottom: 10px;
    text-align: right;
    border-bottom: 1px solid var(--bllink-blue);

    p {
      margin-bottom: 10px;
    }
  }

  .payment-details {
    padding-top: 30px;
  }
  
  @media screen and (max-width: 600px) {
    .DayPickerInput-Overlay {
      bottom: 55px;
    }
    .details {
      flex-direction: column;
    }
    .payment-details {
      .row {
        flex-direction: column;
        &.submit-form {
          margin-top: 25px;
        }
      }
    }
  }
`;

export const StyledSignature = styled.div`
  .sigContainer {
    width: 100%;
    height: 310px;
    margin-bottom: 30px;

    .sigCanvas {
      width: 100%;
      height: 100%;
    }
  }
  .actions {
    justify-content: space-between;

    .bllink-button {
      width: 100%;
    }
  }
  @media screen and (max-width: 600px) {
    .actions {
      & > div {
        &:not(:last-child) {
          margin-bottom: 20px;
        }
      }
    }
  }
`;

export const StyledPdfAgreement = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 1000px;
  height: 1420px;
  direction: rtl;
  text-align: right;

  .wrapper {
    position: relative;
    width: 1000px;
    height: 100%;
    font-family: var(--bllink-font-primary);
    font-size: 26px;
    font-weight: bold;
    background-color: #fff;
  }
  .bg {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: auto;
    img {
      width: 100%;
      height: auto;
    }
  }
  .pdf-data {
    position: absolute;
    margin: 0;
    padding: 0;
    font-size: 26px;
    
    &.address {
      min-width: 400px;
      top: calc(50% + 75px);
      right: 200px;
    }
    &.phone {
      top: calc(50% + 130px);
      right: 200px;
    }
    &.phone-in-table {
      top: calc(50% - 205px);
      left: 180px;
    }
    &.email {
      top: calc(50% + 130px);
      left: 150px;
    }
    &.bank-code {
      top: calc(50% - 285px);
      left: 98px;
      letter-spacing: 12px;
    }
    &.branch-code-right {
      top: calc(50% - 230px);
      right: 150px;
    }
    &.branch {
      top: calc(50% - 285px);
      left: 153px;
      letter-spacing: 11px;
    }
    &.account {
      top: calc(50% - 285px);
      left: 298px;
      letter-spacing: 6.5px;
    }
    &.check {
      top: calc(50% - 153px);
      right: 101px;
    }
    &.bank-name {
      min-width: 300px;
      top: calc(50% - 270px);
      right: 145px;
      font-size: 22px;
    }
    &.owner-id {
      min-width: 180px;
      top: calc(50% + 20px);
      left: 140px;
    }
    &.name {
      min-width: 380px;
      top: calc(50% + 20px);
      right: 200px;
    }
    &.date {
      bottom: 75px;
      right: 170px;
    }
    &.signature {
      left: 80px;
      bottom: 60px;
      width: 200px;
      height: auto;
      img {
        width: 100%;
        height: auto;
      }
    }
  }
`;

export const StyledContainer = styled.div`
  .fade-enter .transition-item {
    opacity: 0;
    transform: translateX(-100%);
  }

  .fade-enter-active .transition-item {
    opacity: 1;
    transform: translateX(0%);
  }

  .fade-exit .transition-item {
    opacity: 1;
    transform: translateX(0%);
  }

  .fade-exit-active .transition-item {
    opacity: 0;
    transform: translateX(100%);
  }

  .fade-enter-active .transition-item,
  .fade-exit-active .transition-item {
    transition: opacity 500ms, transform 500ms;
  }
`;
